const rules = {
  required: (v) => !!v || 'Required',
  requiredAllowEmpty: (v) => (v !== undefined && v != null) || 'Required',
  requiredArray: (v) => v.length > 0 || 'Required',
  requiredArrayWithoutFalsy: (v) => v.filter((x) => x).length > 0 || 'Required',
  phone: (v) =>
    /^\d{3}[-.]?\d{3}[-.]?\d{4}$/.test(v) || v == null || 'Invalid phone number (XXX-XXX-XXXX)',
  email: (v) =>
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
      v
    ) || 'Invalid Email',
  emailDomain: (v) =>
    /^@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
      v
    ) || 'Invalid Email Domain (@company.com)',
  postalCode: (v) => /^([0-9]{5})$/.test(v) || 'Invalid Postal Code',
  password: (v) => {
    const pattern = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_.])(?=.{8,})/;
    return (
      !v ||
      pattern.test(v) ||
      'Min. 8 characters with at least one capital letter, a number and a special character (!,@,#,$,%,^,&,*,_,.).'
    );
  },
  double: (v) => {
    return /^[0-9]+.[0-9]+$/.test(v) || 'Invalid number';
  },
  int: (v) => {
    return /^[0-9]+$/.test(v) || 'Invalid number';
  },
  jsonValid: (v) => {
    if (!v) return true; // empty is allowed (no fold animation)
    try {
      JSON.parse(v);
      return true;
    } catch (e) {
      return 'Invalid JSON';
    }
  }
};

export default rules;
